module.exports = __webpack_public_path__ + "c762c5de327abc9812b19668764ae57a.png";